import classnames from 'classnames'

import type { IconTypes } from '~/components/atoms/Icon/Icon'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { LinkProps } from '~/components/links'
import { resolveLink } from '~/components/serializers'

import Button, { ButtonVariants } from '../Button/Button'

import styles from './IconWithText.module.css'

export interface IconWithTextProps {
  icon: IconTypes
  text: string
  title?: string
  link?: LinkProps
  className?: string
  launchForm?: string
  testID?: string
}

export default function IconWithText({
  icon,
  text,
  title,
  link,
  className,
  launchForm,
  testID,
}: IconWithTextProps) {
  return (
    <div className={classnames(styles.base, className)} data-testid={testID}>
      <div className={styles.icon}>
        <Icon type={icon} responsive={true} />
      </div>
      {title && (
        <Text
          Tag="p"
          size={TextSizes.primaryTitleMed}
          className={classnames(styles.title, link && styles.titleWithLink)}
        >
          {title}
        </Text>
      )}
      <Text
        Tag="p"
        size={TextSizes.bodyLrg}
        className={classnames(styles.text, link && styles.textWithLink)}
      >
        {text}
      </Text>
      {link?.text && (
        <Button
          iconLeft={true}
          link={resolveLink(link)}
          variant={ButtonVariants.primaryDark}
          testID={testID}
          launchForm={launchForm}
          gaTrack={link.gaTrack}
          gaTrackEventName={link.gaTrackEventName}
          phWebProduct={link?.phWebProduct}
          phInteractionLocation={link?.phInteractionLocation}
          phEventName={link?.phEventName}
          phCTASource={link?.phCTASource}
        >
          {link.text}
        </Button>
      )}
    </div>
  )
}
